/* @flow */
export type ResponseInterceptorType = (response: Object) => boolean;

export function serviceUnavailableInterceptor(response: Object): boolean {
  if (response.statusCode === 503) {
    const ToastActions = require('actions/ToastActions').default;
    ToastActions.showErrorToast(
      'We are currently experiencing some technical issues. Try again later.'
    );
    return true;
  }
  return false;
}

export function unauthorizedInterceptor(response: Object): boolean {
  if (response.statusCode === 401) {
    const AuthActions = require('auth/AuthActions').default;
    AuthActions.expireSession();
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/lib/ResponseInterceptors.js